module.exports = __webpack_public_path__ + "static/lisa_maxwell-41534fdfc8566ef7c2d29ac165c48249.jpg";